import React from "react";
import "./grayCard.scss";
const GrayCard = ({
  border = false,
  children,
  className = "",
  style = {},
  onClick,
  moreWhite = false,
  moreBlue = false,
  moreRed = false,
  moreYellow = false,
  brightOrange = false,
  moreDark = false,
  hover = false,
  ...rest
}) => {
  return (
    <div
      className={`common-gray-card ${border ? "border" : ""} ${className} 
      ${moreDark ? "more-dark" : ""} 
      ${moreWhite ? "more-white" : ""} 
      ${moreBlue ? "more-blue" : ""} 
      ${moreRed ? "more-red" : ""} 
      ${moreYellow ? "more-yellow" : ""} 
      ${brightOrange ? "bright-orange" : ""} 
      ${hover ? "hover" : ""}`}
      style={style}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
};

export default GrayCard;
